import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/PageHero";
import { Stagger, item } from "@/components/Reveal";

export default function Insights() {
  const { content } = useLang();
  const { ui } = content;
  const insights = content.insights || [];

  return (
    <>
      <PageHero title={ui.pointsOfView} intro={[]} compact />
      <section className="bg-white" data-testid="insights-list-section">
        <div className="container-x py-16 md:py-24">
          <Stagger className="grid grid-cols-1 gap-x-12 gap-y-16 lg:grid-cols-2" stagger={0.1}>
            {insights.map((ins) => (
              <motion.div key={ins.slug} variants={item}>
                <Link to={`/points-de-vue/${ins.slug}`} data-testid={`insight-card-${ins.slug}`} className="group block">
                  <div className="relative overflow-hidden bg-[var(--pov-dark)]">
                    <img src={ins.image} alt={ins.title} loading="lazy" className="aspect-[16/9] w-full object-cover opacity-70 transition-transform duration-700 group-hover:scale-[1.03]" />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#232323] via-[#232323]/75 to-transparent" />
                    <div className="absolute inset-0 flex flex-col justify-end p-8 sm:p-12">
                      <h2 className="font-pov max-w-lg text-2xl md:text-3xl text-white">{ins.title}</h2>
                    </div>
                  </div>
                  <p className="mt-7 font-pov text-lg md:text-xl text-[#1d1d1d]">{ins.subtitle}</p>
                  <p className="mt-5 max-w-2xl text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]">{ins.excerpt}</p>
                  <span className="mt-7 inline-block text-sm text-black underline decoration-black/40 underline-offset-4 transition-colors duration-300 group-hover:decoration-black">{ui.readInsight}</span>
                </Link>
              </motion.div>
            ))}
          </Stagger>
        </div>
      </section>
    </>
  );
}
